module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/101-northern-cyprus-2454a93ccf5ba8a655ef01161dc273cb.svg";